// Señal de cambios de un pedido para la página del comprador (ver
// functions/seguimientoPedido.js). Escucha UN documento mínimo (versión y
// estado): 1 lectura al abrir y 1 por cada cambio que haga el gimnasio. Solo
// cuando la versión supera la que ya se muestra se llama a alCambiar, que trae
// el detalle una vez. Sin botón «Actualizar» ni consultas periódicas.
// Firestore se descarga recién aquí (al tener un pedido que seguir): quien solo
// mira el catálogo no baja el SDK.
import { useEffect, useRef } from 'react';

/** ID de la señal: SHA-256 de «seguimiento|clave» (la clave nunca sale del navegador). */
export const idSenalPedido = async (clave) => {
  const resumen = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(`seguimiento|${clave}`));
  return [...new Uint8Array(resumen)].map((b) => b.toString(16).padStart(2, '0')).join('');
};

/** clave null = no escuchar (pedido terminado o sin clave en este celular). */
export const useSenalPedido = (clave, version, alCambiar) => {
  const actual = useRef({ version, alCambiar });
  actual.current = { version, alCambiar };
  useEffect(() => {
    if (!clave || !window.crypto?.subtle) return undefined;
    let vigente = true, cancelar = () => {};
    Promise.all([idSenalPedido(clave), import('firebase/firestore'), import('../servicios/firebaseBase')]).then(([id, { doc, onSnapshot }, { db }]) => {
      if (!vigente) return;
      cancelar = onSnapshot(doc(db, 'seguimientoPedidos', id), (snap) => {
        const senal = snap.data();
        if (senal && Number(senal.version) > (Number(actual.current.version) || 0)) actual.current.alCambiar(senal);
      }, () => { /* sin señal (pedido anterior o sin conexión): queda lo último mostrado */ });
    }).catch(() => {});
    return () => { vigente = false; cancelar(); };
  }, [clave]);
};
